export const dependencies = [
    require("./../../utils/entityJoin").joinEntities({
        name: "DashboardElement",
        fields: [
            "name", "type", "url", "suffix", "link", "keys", "colors", "width", "sum", "params"
        ]
    }, ["StaticDashboardElement", "DynamicDashboardElement"]),
    {
        name: "DynamicDashboardElement",
        fields: [
            "name", "type", "url", "suffix", "link", "keys", "colors", "width", "sum", "params"
        ],
        db: {
            find: function(context, callback) {
                if(!context.model?.id) return callback(null, [])
                return global.app[context.model.id].DynamicDashboardElement.collection.find({
                    group: new global.ObjectID(context.group.id),
                }).toArray().then((results) => callback(null, results)).catch(callback)
            }
        }
    },
    {
        name: "StaticDashboardElement",
        type: "static",
        fields: [
            {path: "id", type: "id"},
            "name", "type", "url", "suffix", "link", "keys", "colors", "width", "sum"
        ],
        objects: []
    }
]
